"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const controlStyleToAtomStyle_1 = __importDefault(require("../shared/controlStyleToAtomStyle"));
const useAppGetColorFromSpecification_1 = __importDefault(require("./useAppGetColorFromSpecification"));
const useAppGetFontSizeFromSpecification_1 = __importDefault(require("./useAppGetFontSizeFromSpecification"));
const useAppAtomStyleFromControlStyle = () => {
    const getColor = (0, useAppGetColorFromSpecification_1.default)();
    const getFontSize = (0, useAppGetFontSizeFromSpecification_1.default)();
    return (0, react_1.useMemo)(() => (0, controlStyleToAtomStyle_1.default)({
        getFontSize,
        getColor,
    }), [getColor, getFontSize]);
};
exports.default = useAppAtomStyleFromControlStyle;
